import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";
import { storage, db } from "../firebaseConfig";

export const ThumbnailUploader = async (item, newThumbnailFile, currentPath, setRefresh, setThumbnailLoading) => {

  if (!newThumbnailFile || !item?.id) {
    console.error("Invalid item or thumbnail file.");
    return;
  }

  try {
    setThumbnailLoading(true)
    const folderPath = Array.isArray(currentPath) ? currentPath.join('/') : currentPath;
    const id = item.id;

    const thumbRef = ref(storage, `${folderPath}/thumbs/${id}.jpg`);

    const uploadTask = uploadBytesResumable(thumbRef, newThumbnailFile);

    // Wait for upload to complete
    const snapshot = await new Promise((resolve, reject) => {
      uploadTask.on("state_changed", null, reject, () => resolve(uploadTask.snapshot));
    });

    const thumbUrl = await getDownloadURL(snapshot.ref);

    // Construct Firestore path dynamically
    const segments = folderPath.split("/").filter(Boolean);
    let firestorePath = "videos";
    segments.forEach((segment, index) => {
      firestorePath += `/${segment}`;
      if (index !== segments.length - 1) {
        firestorePath += "/items";
      }
    });

    const itemRef = doc(db, `${firestorePath}/items`, id);
    await updateDoc(itemRef, { thumbUrl });

    if (setRefresh) setRefresh(prev => !prev);
    setThumbnailLoading(false);
  } catch (error) {
    console.error("Thumbnail upload failed:", error);
  }
};
